import { Box, Divider, Grid, Typography, styled } from '@mui/material'
import React from 'react'
import { Pages } from '../../constants'
import { NavLink } from "react-router-dom";
import i18next from 'i18next'
import { useTheme } from '@mui/material/styles';

const Navigation = () => {
    let lng = i18next.language
    const theme = useTheme();
    const StyledLink = styled(NavLink)(({ theme, isActive }) => ({
        textDecoration: "none",
        fontSize: 18,
        textTransform: 'capitalize',
        color: isActive ?'#f1c114' : theme.palette.nav.main,
        transition: '0.5s',
        display: 'block',
        margin: '4px 0',
        width: 'fit-content',
        '&:hover': {
            color:'#f1c114',
        },
    }));
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    return (
        <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Box sx={{width:'fit-content', mb:1,mt:2}} >
                <Typography variant='h6' color={'primary.text'} >{lng === 'en' ? 'Information' : 'الصفحات'}</Typography>
                <Divider sx={{borderWidth:1, borderColor:'#d9d9d9'}}/>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Grid container>
                    {Pages?.map((page, i) => (
                        <Grid
                            item
                            xs={6}
                            md={12}
                            key={i}>
                            <StyledLink
                                to={page.path}
                                className={'link'}
                                style={({ isActive }) => ({
                                    color: isActive ?'#f1c114' : theme.palette.nav.main,
                                })}
                                onClick={() => scrollToTop()}
                            >
                                {lng === 'ar' ? page.name : page.name_en}
                            </StyledLink>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}

export default Navigation